import { notify } from 'utils/reduxUtils';

export const types = {
  USER_INFO_INIT: 'settings/userProfile/USER_INFO_INIT',
  USER_INFO_UPDATE_ERROR: 'settings/userProfile/USER_INFO_UPDATE_ERROR',
  USER_INFO_UPDATE_REQUEST: 'settings/userProfile/USER_INFO_UPDATE_REQUEST',
  USER_INFO_UPDATE_SUCCESS: 'settings/userProfile/USER_INFO_UPDATE_SUCCESS',
};

export const userInfo = {
  init: () => ({
    type: types.USER_INFO_INIT,
  }),
};

export const userInfoUpdate = {
  error: notify(
    (error) => ({
      type: types.USER_INFO_UPDATE_ERROR,
      payload: error,
    }),
    "Can't update user info.",
  ),
  request: ({ firstName, lastName }) => ({
    type: types.USER_INFO_UPDATE_REQUEST,
    payload: { firstName, lastName },
  }),
  success: notify(
    () => ({
      type: types.USER_INFO_UPDATE_SUCCESS,
    }),
    'User info successfully updated.',
  ),
};
